export default __webpack_public_path__ + "static/media/element.544577fb.svg";